module.exports = __webpack_public_path__ + "static/img/041 2.0dfce7da.jpg";